import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService, STAFF_ROLES } from '@nebalkon-workspace/auth';

function pathWithoutQueryOrHash(url: string): string {
  return url.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';
}

export const guestOnlyGuard = (): CanMatchFn => () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) return true;

  const path = pathWithoutQueryOrHash(router.url);

  /** User is authenticated but still finishing login on OTP or name screen. */
  if (path === '/auth/otp' || path === '/auth/name') {
    return true;
  }

  const userRoles = authService.roles();

  if (userRoles.some((role) => STAFF_ROLES.includes(role))) {
    return router.createUrlTree(['/stuff']);
  }

  return router.createUrlTree(['/client']);
};
